import { Failure, Ok } from "@megaron/result";
import { Serializer, SerializerExtensions, serializerExtensions, Serializers } from "@megaron/serializers";

export type HttpUri = `http://${string}` | `https://${string}`;

const isHttpUri = (value: unknown): value is HttpUri => {
  if (typeof value !== "string") return false;
  if (!value.startsWith("http://") && !value.startsWith("https://")) return false;

  try {
    new URL(value);
    return true;
  } catch {
    return false;
  }
};

const httpUriSerializer: Serializer<HttpUri> & SerializerExtensions<HttpUri> = {
  serialize: (value) => value,
  deserialize: (value) => {
    const strResult = Serializers.string.deserialize(value);
    if (strResult.isFailure) return strResult;

    if (!isHttpUri(strResult.value)) return Failure("UnknownUri");

    return Ok(strResult.value);
  },

  ...serializerExtensions(),
};

export const HttpUri = {
  serializer: httpUriSerializer,
  isUri: isHttpUri,
};
